import { createRootRoute, redirect } from '@tanstack/react-router'
import App from '@/components/App'
import NotFound from './not-found'
import { auth } from '@/shared/auth'
import CoinAnimation from '@/ui/loader'
import { Route as WaitList } from './waitlist'
import { Route as Banned } from './banned'
import { Route as Chances } from './chances'
import { logMsg } from '@/shared/lib/sentry'

export const Route = createRootRoute({
  component: () => <App />,
  notFoundComponent: () => <NotFound />,
  pendingComponent: CoinAnimation,
  beforeLoad: async ({ location }) => {
    const r = await auth()
    if (location.pathname === Banned.fullPath) return

    if (!r || !r.permissions.length) {
      logMsg('Auth guard: no permissions or empty auth response', 'warning', {
        path: location.pathname,
        search: location.search,
        reason: !r ? 'no_session' : 'empty_permissions',
        respone: r,
      })
      throw redirect({ to: Banned.fullPath })
    }

    const { permissions } = r

    const canCreateDreams = permissions.some((p) => p.name === 'create_dreams')
    const canReadReferrals = permissions.some(
      (p) => p.name === 'read_referrals',
    )
    const canSpin = permissions.some(({ name }) => name === 'use_roulette')

    // 1️⃣ Разрешён создавать мечты — не должен быть на waitlist
    if (canCreateDreams && location.pathname === WaitList.fullPath) {
      throw redirect({ to: '/' })
    }

    // 2️⃣ Разрешён только читать рефералов — должен быть на waitlist
    if (
      canReadReferrals &&
      !canCreateDreams &&
      location.pathname !== WaitList.fullPath
    ) {
      if (canSpin && location.pathname === Chances.fullPath) return
      throw redirect({ to: WaitList.fullPath })
    }

    // 3️⃣ Нет ни того, ни другого разрешения — бан
    if (
      !canCreateDreams &&
      !canReadReferrals &&
      location.pathname !== Banned.fullPath
    ) {
      logMsg(
        'Auth guard: banned redirect due to missing required permissions',
        'warning',
        {
          path: location.pathname,
          permissions: permissions.map((p) => p.name),
        },
      )
      throw redirect({ to: Banned.fullPath })
    }
  },
})
